export default "__VITE_ASSET__9eblAXyN__"